import { virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { js_utils } from "../utils/frfr-js-utils";
import { SPACE } from "../utils/frfr-string-consts";
import { derivatAutoCreateVirtel_spoljnafiksnazaluzina, derivatAutoCreateVirtel_spoljnafiksnazaluzina_priprema_ulaza } from "./ter-derivat-lib-terkk-spoljnafiksnazaluzina";
import { virbomCounter } from "../utils/frfr-virbom-counter-utils";
import { _virbom_manipulator } from "../utils/frfr-virbom-manipulator-utils";


// TER DRAFTEL CODECS LIB

/*

*/


export const draftel_codecs_pack_terkk$spoljnafiksnazaluzina = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_terkk$spoljnafiksnazaluzina.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$spoljnafiksnazaluzina',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno
    tipspoljnefiksnezaluzine: 'standardni',
    unutrasnjasirina: null,
    unutrasnjavisina: null,
    kolicina: 1,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$spoljnafiksnazaluzina.keys_for_direct_cloning = [
  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  ...Object.keys(draftel_codecs_pack_terkk$spoljnafiksnazaluzina.default_preset_state())
];


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------


draftel_codecs_pack_terkk$spoljnafiksnazaluzina.drafel_to_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima
  const sema = virtel_schema_smart_get('terkk$spoljnafiksnazaluzina');
  console.log(formState);
  let state = {
    ...formState
  };
  const p = state;
  const spfNaziv = 'SPOLJNA FIKSNA ZALUZINA' + SPACE +
    p.tipspoljnefiksnezaluzine.toUpperCase() + SPACE +
    p.unutrasnjasirina + 'x' + p.unutrasnjavisina;
  state.naziv = spfNaziv;
  //
  const state2 = {
    virtelschemakey: 'terkk$spoljnafiksnazaluzina',
    ...state,
    flag_paired_with_smartel: true, // ovaj virtel direktno uparen sa smartel.subkey
    ..._get_fixed_fields(sema),
    ..._getParamsFromLib("terkk$spoljnafiksnazaluzina") // parametri na kraju imaju prioritet
  };
  return state2; // return virtel
};


draftel_codecs_pack_terkk$spoljnafiksnazaluzina.drafel_to_virbom = (draftel) => {
  // MAIN CONVERT METHOD
  // const sema = virtel_schema_smart_get('terkk$spoljnafiksnazaluzina');
  const virtel = draftel_codecs_pack_terkk$spoljnafiksnazaluzina.drafel_to_virtel(draftel);

  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);

  // KORAK poluproizvod level 3 virtel
  // graphlevel: 3,
  // const graphlevel = 3;
  const local_graphlevel = 1;
  // _virbom_manipulator.add_on_graphlevel(virbom_ref, virtel_demper, 3);
  _virbom_manipulator.add_as_first_virtel(virbom_ref, virtel);

  // KORAK pripreme derivata za
  let pods_input_za_derivate = derivatAutoCreateVirtel_spoljnafiksnazaluzina_priprema_ulaza(draftel); // ??? 
  let _derivati = derivatAutoCreateVirtel_spoljnafiksnazaluzina(pods_input_za_derivate);
  console.log('_derivati spoljnafiksnazaluzina');
  console.log(_derivati);
  // USISAVANJE
  _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _derivati, local_graphlevel + 1, virbomCounter.generateFreshSubkey);

  // ZAVRSENI KORACI ZA JEDAN pp3

  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  return virbom_seq; // return virbom
};


// ---------- CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION ----------


draftel_codecs_pack_terkk$spoljnafiksnazaluzina.virtel_to_draftel = (virtel) => {
  // pretvara iz virtela u formState format
  //
  let state = {
    ...draftel_codecs_pack_terkk$spoljnafiksnazaluzina.default_preset_state(),
    ...js_utils.clone_obj_but_only_selected_keys(virtel, draftel_codecs_pack_terkk$spoljnafiksnazaluzina.keys_for_direct_cloning)
  };
  //
  return state;
};

